// AUTO-GENERATED by gatsby-node.ts at build time — do not edit

// An ordering region (e.g. new_york) in a metro, centered on all its
// locations with upcoming events (none without any). Fixed at build
// time: rebuild after a metro gains or loses one.
export type OrderRegion = {
	key: string
	center?: {lat: number; lng: number}
}

export type Region = {
	name: string
	key: string
	center: {lat: number; lng: number}
	zone: string
	// Most locations first
	orderRegions: OrderRegion[]
}

export const AllRegions: Region[] = [
	{
		name: 'Austin, TX',
		key: 'austin',
		center: {lat: 30.314373, lng: -97.727758},
		zone: 'America/Chicago',
		orderRegions: [
			{key: 'texas', center: {lat: 31.923345083333, lng: -96.995637618333}},
		],
	},
	{
		name: 'Boston, MA',
		key: 'boston',
		center: {lat: 42.3492, lng: -71.0751},
		zone: 'America/New_York',
		orderRegions: [
			{key: 'massachusetts', center: {lat: 42.3514359, lng: -71.0766349}},
		],
	},
	{
		name: 'Chicago, IL',
		key: 'chicago',
		center: {lat: 41.8781, lng: -87.6298},
		zone: 'America/Chicago',
		orderRegions: [
		],
	},
	{
		name: 'Dallas, TX',
		key: 'dallas',
		center: {lat: 32.826385, lng: -96.834987},
		zone: 'America/Chicago',
		orderRegions: [
			{key: 'texas', center: {lat: 31.923345083333, lng: -96.995637618333}},
		],
	},
	{
		name: 'Denver, CO',
		key: 'denver',
		center: {lat: 39.7392, lng: -104.9903},
		zone: 'America/Denver',
		orderRegions: [
			{key: 'colorado', center: {lat: 39.754147785714, lng: -105.032196571429}},
		],
	},
	{
		name: 'Houston, TX',
		key: 'houston',
		center: {lat: 29.741715, lng: -95.450667},
		zone: 'America/Chicago',
		orderRegions: [
			{key: 'texas', center: {lat: 31.923345083333, lng: -96.995637618333}},
		],
	},
	{
		name: 'Los Angeles, CA',
		key: 'socal',
		center: {lat: 34.03105, lng: -118.416064},
		zone: 'America/Los_Angeles',
		orderRegions: [
		],
	},
	{
		name: 'Miami, FL',
		key: 'miami',
		center: {lat: 25.7617, lng: -80.1918},
		zone: 'America/New_York',
		orderRegions: [
		],
	},
	{
		name: 'New York, NY',
		key: 'nyc_metro',
		center: {lat: 40.7128, lng: -74.006},
		zone: 'America/New_York',
		orderRegions: [
			{key: 'new_york', center: {lat: 40.7385356, lng: -73.9922313}},
		],
	},
	{
		name: 'Oakland, CA',
		key: 'norcal',
		center: {lat: 37.8044, lng: -122.2712},
		zone: 'America/Los_Angeles',
		orderRegions: [
		],
	},
	{
		name: 'Orange County, CA',
		key: 'socal',
		center: {lat: 33.718727, lng: -117.939638},
		zone: 'America/Los_Angeles',
		orderRegions: [
		],
	},
	{
		name: 'San Diego, CA',
		key: 'san_diego',
		center: {lat: 32.8245, lng: -117.2249},
		zone: 'America/Los_Angeles',
		orderRegions: [
		],
	},
	{
		name: 'San Francisco, CA',
		key: 'norcal',
		center: {lat: 37.784909, lng: -122.402654},
		zone: 'America/Los_Angeles',
		orderRegions: [
		],
	},
	{
		name: 'San Jose, CA',
		key: 'norcal',
		center: {lat: 37.387842, lng: -121.971981},
		zone: 'America/Los_Angeles',
		orderRegions: [
		],
	},
	{
		name: 'Seattle, WA',
		key: 'seattle',
		center: {lat: 47.58403, lng: -122.232529},
		zone: 'America/Los_Angeles',
		orderRegions: [
			{key: 'washington', center: {lat: 47.528887174286, lng: -122.367189777143}},
		],
	},
	{
		name: 'Washington, DC',
		key: 'dmv',
		center: {lat: 38.8977, lng: -77.0365},
		zone: 'America/New_York',
		orderRegions: [
		],
	},
];
